var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingActive),expression:"loadingActive"}],ref:"pdfContainer",attrs:{"id":"pdfContainer","element-loading-text":"拼命加载中"}},[_c('iframe',{attrs:{"src":_vm.urlSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }